<script setup lang="ts">
import { ref } from "vue";

import EmptyState from "./empty-state.vue";
import ReportBySDG from "./sdg-impact-by-sdg.vue";
import ChartsWidget from "./charts-widget.vue";
import ChartsWrapper from "../../components/common/charts-wrapper/charts-wrapper.vue";
import ReportByCompany from "./sdg-impact-by-company.vue";
import ViTabs from "@/components/elements/vi-tabs/vi-tabs.vue";
import ViSelect from "@/components/elements/vi-select/vi-select.vue";

import { useCompanyList } from "./../../composables/useCompanyList";

const {
  lists,
  selectedList,
  gotoSelectedList,
  gotoListCreationPage,
  emptyOrNoList,
} = useCompanyList();

const tabs = ref([
  {
    id: "by-company",
    label: "Impact by Company",
    component: ReportByCompany,
  },
  {
    id: "by-sdg",
    label: "Impact by SDG",
    component: ReportBySDG,
  },
]);

const selectedTab = ref(tabs.value[0].id);
const handleTabChange = (tabName: string) => {
  selectedTab.value = tabName;
};
const onListSelect = (listUid: string) => {
  selectedList.value = listUid;
};
</script>

<template>
  <div class="sdg-reports-dashboard">
    <header>
      <div class="company_lists__select">
        <p>{{ $t(`chartsDashboard.select[0]`) }}</p>
        <ViSelect
          option-key-key="uid"
          option-value-key="uid"
          option-label-key="title"
          :options="lists"
          :selected-option="selectedList"
          @change="onListSelect"
        />
      </div>

      <PxButton :disabled="emptyOrNoList" size="medium" icon="download">
        Download Full Report
      </PxButton>
    </header>

    <ChartsWrapper>
      <EmptyState
        v-if="emptyOrNoList"
        :type="lists.length <= 0 ? `lists` : `companies`"
        :on-open-list="gotoSelectedList"
        :on-create-list="gotoListCreationPage"
      />
      <ChartsWidget v-else>
        <ViTabs
          :tabs="tabs"
          :selected-tab="selectedTab"
          @change="handleTabChange"
        />
      </ChartsWidget>
    </ChartsWrapper>
  </div>
</template>

<style scoped lang="scss">
.sdg-reports-dashboard {
  header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .company_lists__select {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: flex-start;
    }

    p {
      min-width: 80px;
    }
  }
}
</style>
